"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ICON_NAMES = void 0;
var ICON_NAMES = {
  active: 'active',
  age: 'age',
  alert: 'alert',
  apple: 'apple',
  arrow_left: 'arrow_left',
  arrow_right: 'arrow_right',
  basics: 'basics',
  block: 'block',
  bodytype: 'bodytype',
  boost_f: 'boost_f',
  boost: 'boost',
  boostlist: 'boostlist',
  calendar: 'calendar',
  camera: 'camera',
  cameraroll: 'camera_roll',
  carat_down: 'carat_down',
  carat_left: 'carat_left',
  carat_right: 'carat_right',
  carat_up: 'carat_up',
  check: 'check',
  circlecheck_unfilled: 'circlecheck_unfilled',
  circlecheck: 'circlecheck',
  circlecross: 'circlecross',
  close: 'close',
  coach: 'coach',
  college: 'college',
  cross: 'cross',
  crosscircle: 'crosscircle',
  dates: 'dates',
  delete: 'delete',
  discover: 'discover',
  drink: 'drink',
  edit: 'edit',
  education: 'education',
  elipses_vert: 'elipses_vert',
  elipses: 'elipses',
  email: 'email',
  ethnicity: 'ethnicity',
  events: 'events',
  exercise: 'exercise',
  eyes: 'eyes',
  facebook: 'facebook',
  faith: 'faith',
  filter: 'filter',
  folder: 'folder',
  gender: 'gender',
  hair: 'hair',
  havekids: 'havekids',
  heart_check: 'heart_check',
  height: 'height',
  help: 'help',
  history: 'history',
  home: 'home',
  hometown: 'hometown',
  inbox: 'inbox',
  income: 'income',
  info: 'info',
  instagram: 'instagram',
  interests: 'interests',
  languages: 'languages',
  lifestyle: 'lifestyle',
  like_f: 'like_f',
  like: 'like',
  location: 'location',
  login: 'login',
  looks: 'looks',
  marijuana: 'marijuana',
  match_me: 'match_me',
  matches: 'matches',
  matchphone: 'matchphone',
  message_for_free: 'message_for_free',
  message: 'message',
  message_f: 'message_f',
  nopreference: 'nopreference',
  occupation: 'occupation',
  pass: 'pass',
  password: 'password',
  personal: 'personal',
  pets: 'pets',
  phone: 'phone',
  photo_caption: 'photo_caption',
  photo: 'photo',
  politics: 'politics',
  premium: 'premium',
  privatemode: 'privatemode',
  profilepro: 'profilepro',
  question: 'question',
  quote: 'quote',
  recentlyactive: 'recentlyactive',
  refresh: 'refresh',
  relationships: 'relationships',
  report: 'report',
  rff: 'rff',
  rewind: 'rewind',
  safetycenter: 'safetycenter',
  savesearch: 'savesearch',
  settings: 'settings',
  shortcuts: 'shortcuts',
  sign: 'sign',
  singlecheck: 'singlecheck',
  smoke: 'smoke',
  sort: 'sort',
  sports: 'sports',
  starfill: 'starfill',
  starstroke: 'starstroke',
  subscribe: 'subscribe',
  subscriber_f: 'subscriber_f',
  triangle_down: 'triangle_down',
  triangle_left: 'triangle_left',
  triangle_right: 'triangle_right',
  triangle_up: 'triangle_up',
  top_pick: 'top_pick',
  twitter: 'twitter',
  user: 'user',
  verified: 'verified',
  views: 'views',
  video: 'video',
  videoFilled: 'video_filled',
  wantkids: 'wantkids'
};
exports.ICON_NAMES = ICON_NAMES;